import React from "react";
import { Navbar, NavbarComarchBrand, Nav, NavItem, Icon, NavbarLoggedUser } from "@optimed/react";
import { routes } from "./routes";

export function MainNavbar() {
  return (
    <Navbar fixedTop>
      <NavbarComarchBrand appName="Optimed Docplanner" />
      <div style={{ display: "inline-block", width: 20 }} />
      <Nav>
        <NavItem to={routes.doctors}>
          <Icon icon="user-md" /> Lekarze
        </NavItem>
        <NavItem to={routes.services}>
          <Icon icon="syringe" /> Procedury
        </NavItem>
        <NavItem to={routes.schedules}>
          <Icon icon="calendar-alt" /> Grafiki
        </NavItem>
        <NavItem to={routes.bookings}>
          <Icon icon="notes-medical" /> Wizyty
        </NavItem>
        <NavItem to={routes.events}>
          <Icon icon="history" /> Zdarzenia
        </NavItem>
      </Nav>
      <NavbarLoggedUser />
    </Navbar>
  );
}
